function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M188.741 58H7.25926C3.19407 58 0 54.81 0 50.75V7.25C0 3.19 3.19407 0 7.25926 0H188.741C192.806 0 196 3.19 196 7.25V50.75C196 54.81 192.806 58 188.741 58Z",
  fill: "black"
}), React.createElement("path", {
  d: "M188.741 1.16C192.08 1.16 194.839 3.915 194.839 7.25V50.75C194.839 54.085 192.08 56.84 188.741 56.84H7.25926C3.92 56.84 1.16148 54.085 1.16148 50.75V7.25C1.16148 3.915 3.92 1.16 7.25926 1.16H188.741ZM188.741 0H7.25926C3.19407 0 0 3.335 0 7.25V50.75C0 54.81 3.19407 58 7.25926 58H188.741C192.806 58 196 54.81 196 50.75V7.25C196 3.335 192.806 0 188.741 0Z",
  fill: "#A6A6A6"
}), React.createElement("path", {
  d: "M68.8176 14.7899C68.8176 15.9499 68.5272 16.9649 67.8013 17.6899C66.9301 18.5599 65.9138 18.9949 64.6072 18.9949C63.3005 18.9949 62.2842 18.5599 61.4131 17.6899C60.542 16.8199 60.1064 15.8049 60.1064 14.4999C60.1064 13.1949 60.542 12.1799 61.4131 11.3099C62.2842 10.4399 63.3005 10.0049 64.6072 10.0049C65.1879 10.0049 65.7687 10.1499 66.3494 10.4399C66.9301 10.7299 67.3657 11.0199 67.6561 11.4549L66.9301 12.1799C66.3494 11.4549 65.6235 11.1649 64.6072 11.1649C63.7361 11.1649 62.865 11.4549 62.2842 12.1799C61.5583 12.7599 61.2679 13.6299 61.2679 14.6449C61.2679 15.6599 61.5583 16.5299 62.2842 17.1099C63.0101 17.6899 63.7361 18.1249 64.6072 18.1249C65.6235 18.1249 66.3494 17.8349 67.0753 17.1099C67.5109 16.6749 67.8013 16.0949 67.8013 15.3699H64.6072V14.2099H68.8176C68.8176 14.3549 68.8176 14.6449 68.8176 14.7899Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M75.4955 11.1649H71.5755V13.9199H75.2052V14.9349H71.5755V17.6899H75.4955V18.8499H70.4141V10.1499H75.4955V11.1649Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M80.2878 18.8499H79.1264V11.1649H76.6582V10.1499H82.756V11.1649H80.2878V18.8499Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M86.9658 18.8499V10.1499H88.1273V18.8499H86.9658Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M93.0632 18.8499H91.9017V11.1649H89.4336V10.1499H95.3862V11.1649H92.918V18.8499H93.0632Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M106.856 17.6899C105.985 18.5599 104.969 18.9949 103.662 18.9949C102.355 18.9949 101.339 18.5599 100.468 17.6899C99.5967 16.8199 99.1611 15.8049 99.1611 14.4999C99.1611 13.1949 99.5967 12.1799 100.468 11.3099C101.339 10.4399 102.355 10.0049 103.662 10.0049C104.969 10.0049 105.985 10.4399 106.856 11.3099C107.727 12.1799 108.163 13.1949 108.163 14.4999C108.163 15.8049 107.727 16.8199 106.856 17.6899ZM101.339 16.9649C101.92 17.5449 102.791 17.9799 103.662 17.9799C104.533 17.9799 105.404 17.6899 105.985 16.9649C106.566 16.3849 107.001 15.5149 107.001 14.4999C107.001 13.4849 106.711 12.6149 105.985 12.0349C105.404 11.4549 104.533 11.0199 103.662 11.0199C102.791 11.0199 101.92 11.3099 101.339 12.0349C100.758 12.6149 100.323 13.4849 100.323 14.4999C100.323 15.5149 100.613 16.3849 101.339 16.9649Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M109.76 18.8499V10.1499H111.066L115.277 16.9649V15.2249V10.1499H116.438V18.8499H115.277L110.776 11.7449V13.4849V18.8499H109.76Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.2,
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M98.8709 31.6099C95.3865 31.6099 92.6279 34.2199 92.6279 37.8449C92.6279 41.3249 95.3865 44.0799 98.8709 44.0799C102.355 44.0799 105.114 41.4699 105.114 37.8449C105.114 34.0749 102.355 31.6099 98.8709 31.6099ZM98.8709 41.4699C96.9835 41.4699 95.3865 39.8749 95.3865 37.6999C95.3865 35.5249 96.9835 33.9299 98.8709 33.9299C100.758 33.9299 102.355 35.3799 102.355 37.6999C102.355 39.8749 100.758 41.4699 98.8709 41.4699ZM85.3687 31.6099C81.8842 31.6099 79.1257 34.2199 79.1257 37.8449C79.1257 41.3249 81.8842 44.0799 85.3687 44.0799C88.8531 44.0799 91.6116 41.4699 91.6116 37.8449C91.6116 34.0749 88.8531 31.6099 85.3687 31.6099ZM85.3687 41.4699C83.4813 41.4699 81.8842 39.8749 81.8842 37.6999C81.8842 35.5249 83.4813 33.9299 85.3687 33.9299C87.2561 33.9299 88.8531 35.3799 88.8531 37.6999C88.8531 39.8749 87.2561 41.4699 85.3687 41.4699ZM69.2531 33.4949V36.1049H75.4961C75.3509 37.5549 74.7702 38.7149 74.0442 39.4399C73.1731 40.3099 71.7213 41.3249 69.2531 41.3249C65.3331 41.3249 62.4294 38.2799 62.4294 34.3649C62.4294 30.4499 65.4783 27.4049 69.2531 27.4049C71.2857 27.4049 72.8828 28.2749 74.0442 29.2899L75.9316 27.4049C74.3346 25.9549 72.302 24.7949 69.3983 24.7949C64.1716 24.7949 59.6709 29.1449 59.6709 34.3649C59.6709 39.5849 64.1716 43.9349 69.3983 43.9349C72.302 43.9349 74.3346 43.0649 76.0768 41.1799C77.8191 39.4399 78.3998 36.9749 78.3998 35.0899C78.3998 34.5099 78.3998 33.9299 78.2546 33.4949H69.2531ZM135.167 35.5249C134.586 34.0749 133.135 31.6099 129.941 31.6099C126.746 31.6099 124.133 34.0749 124.133 37.8449C124.133 41.3249 126.746 44.0799 130.231 44.0799C132.989 44.0799 134.732 42.3399 135.312 41.3249L133.28 39.8749C132.554 40.8899 131.683 41.6149 130.231 41.6149C128.779 41.6149 127.908 41.0349 127.182 39.7299L135.458 36.2499L135.167 35.5249ZM126.746 37.5549C126.746 35.2349 128.634 33.9299 129.941 33.9299C130.957 33.9299 131.973 34.5099 132.263 35.2349L126.746 37.5549ZM119.923 43.4999H122.681V25.3749H119.923V43.4999ZM115.567 32.9149C114.841 32.1899 113.68 31.4649 112.228 31.4649C109.179 31.4649 106.275 34.2199 106.275 37.6999C106.275 41.1799 109.034 43.7899 112.228 43.7899C113.68 43.7899 114.841 43.0649 115.422 42.3399H115.567V43.2099C115.567 45.5299 114.261 46.8349 112.228 46.8349C110.631 46.8349 109.469 45.6749 109.179 44.6599L106.856 45.6749C107.582 47.2699 109.324 49.2999 112.373 49.2999C115.567 49.2999 118.181 47.4149 118.181 42.9199V31.8999H115.567V32.9149ZM112.373 41.4699C110.486 41.4699 108.889 39.8749 108.889 37.6999C108.889 35.5249 110.486 33.9299 112.373 33.9299C114.261 33.9299 115.712 35.5249 115.712 37.6999C115.712 39.8749 114.261 41.4699 112.373 41.4699ZM147.798 25.3749H141.265V43.4999H144.023V36.6849H147.798C150.847 36.6849 153.751 34.5099 153.751 31.0299C153.751 27.5499 150.847 25.3749 147.798 25.3749ZM147.944 34.0749H144.023V27.8399H147.944C149.976 27.8399 151.138 29.5799 151.138 30.8849C150.992 32.4799 149.831 34.0749 147.944 34.0749ZM164.64 31.4649C162.607 31.4649 160.575 32.3349 159.849 34.2199L162.317 35.2349C162.898 34.2199 163.769 33.9299 164.785 33.9299C166.237 33.9299 167.544 34.7999 167.689 36.2499V36.3949C167.253 36.1049 166.092 35.6699 164.93 35.6699C162.317 35.6699 159.703 37.1199 159.703 39.7299C159.703 42.1949 161.881 43.7899 164.204 43.7899C166.092 43.7899 166.963 42.9199 167.689 42.0499H167.834V43.4999H170.447V36.5399C170.157 33.3499 167.689 31.4649 164.64 31.4649ZM164.349 41.4699C163.478 41.4699 162.172 41.0349 162.172 39.8749C162.172 38.4249 163.769 37.9899 165.075 37.9899C166.237 37.9899 166.818 38.2799 167.544 38.5699C167.253 40.3099 165.801 41.4699 164.349 41.4699ZM179.594 31.8999L176.545 39.7299H176.4L173.206 31.8999H170.302L175.093 42.9199L172.335 49.0099H175.093L182.498 31.8999H179.594ZM155.203 43.4999H157.961V25.3749H155.203V43.4999Z",
  fill: "white"
}), React.createElement("path", {
  d: "M15.0993 10.875C14.6637 11.31 14.5186 12.035 14.5186 12.905V44.95C14.5186 45.82 14.8089 46.545 15.2445 46.98L15.3897 47.125L33.3926 29.145V29V28.855L15.0993 10.875Z",
  fill: "url(#paint0_linear)"
}), React.createElement("path", {
  d: "M39.2006 35.2349L33.248 29.2899V28.9999V28.8549L39.2006 22.9099L39.3458 23.0549L46.4599 27.1149C48.4925 28.2749 48.4925 30.1599 46.4599 31.3199L39.2006 35.2349Z",
  fill: "url(#paint1_linear)"
}), React.createElement("path", {
  d: "M39.3455 35.09L33.2478 29L15.0996 47.125C15.8255 47.85 16.8418 47.85 18.1485 47.27L39.3455 35.09Z",
  fill: "url(#paint2_linear)"
}), React.createElement("path", {
  d: "M39.3455 22.9098L18.1485 10.8748C16.8418 10.1498 15.8255 10.2948 15.0996 11.0198L33.2478 28.9998L39.3455 22.9098Z",
  fill: "url(#paint3_linear)"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M39.2003 34.9448L18.1485 46.8348C16.987 47.5598 15.9707 47.4148 15.2448 46.8348L15.0996 46.9798L15.2448 47.1248C15.9707 47.7048 16.987 47.8498 18.1485 47.1248L39.2003 34.9448Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.12,
  d: "M15.0993 46.8347C14.6637 46.3997 14.5186 45.6747 14.5186 44.8047V44.9497C14.5186 45.8197 14.8089 46.5447 15.2445 46.9797V46.8347H15.0993Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.12,
  d: "M46.4595 30.885L39.2002 34.945L39.3454 35.09L46.4595 31.03C47.4757 30.45 47.9113 29.725 47.9113 29C47.9113 29.725 47.3306 30.305 46.4595 30.885Z",
  fill: "black"
}), React.createElement("path", {
  opacity: 0.25,
  d: "M18.1482 11.0199L46.4593 27.1149C47.3304 27.6949 47.9111 28.2749 47.9111 28.9999C47.9111 28.2749 47.4756 27.5499 46.4593 26.9699L18.1482 10.8749C16.1156 9.71485 14.5186 10.5849 14.5186 12.9049V13.0499C14.5186 10.8749 16.1156 9.85985 18.1482 11.0199Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 31.6498,
  y1: 12.6292,
  x2: 7.31537,
  y2: 36.9948,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#00A0FF"
}), React.createElement("stop", {
  offset: 0.00657445,
  stopColor: "#00A1FF"
}), React.createElement("stop", {
  offset: 0.2601,
  stopColor: "#00BEFF"
}), React.createElement("stop", {
  offset: 0.5122,
  stopColor: "#00D2FF"
}), React.createElement("stop", {
  offset: 0.7604,
  stopColor: "#00DFFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 49.123,
  y1: 29.0021,
  x2: 13.9927,
  y2: 29.0021,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFE000"
}), React.createElement("stop", {
  offset: 0.4087,
  stopColor: "#FFBD00"
}), React.createElement("stop", {
  offset: 0.7754,
  stopColor: "#FFA500"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 36.0453,
  y1: 32.3295,
  x2: 3.04582,
  y2: 65.3711,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF3A44"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 10.5948,
  y1: 0.255479,
  x2: 25.3306,
  y2: 15.0099,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#32A071"
}), React.createElement("stop", {
  offset: 0.0685,
  stopColor: "#2DA771"
}), React.createElement("stop", {
  offset: 0.4762,
  stopColor: "#15CF74"
}), React.createElement("stop", {
  offset: 0.8009,
  stopColor: "#06E775"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 194,
  height: 60,
  fill: "white"
})));

var SvgGoogleStore = function SvgGoogleStore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 196,
    height: 60,
    viewBox: "0 0 196 60",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGoogleStore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googleStore.7ed4440d.svg";
export { ForwardRef as ReactComponent };